// ProductMoreInfo.jsx
import React from "react";

export default function ProductMoreInfo({ isMobile }) {
  return (
    <div>
      {/* TABS */}
      <div
        style={{
          display: "flex",
          gap: isMobile ? "10px" : "15px",
          marginTop: "40px",
          flexWrap: "wrap",
          justifyContent: isMobile ? "center" : "flex-start",
        }}
      >
        <button style={activeTab}>Description</button>
        {/* <button style={tab}>Reviews</button>
        <button style={tab}>Resources</button> */}
      </div>

      {/* FULL DESCRIPTION */}
      <p style={{ marginTop: "20px" }}>
        Jowar, also known as sorghum, is a nutrient-rich, gluten-free ancient grain widely grown in India, Africa, and parts of Asia.
Jowar is commonly used in traditional foods as well as modern healthy diets, making it a popular choice among health-conscious consumers.

      </p>

      <h3>Key Features:</h3>
      <ul>
        <li>Source: Derived from the sorghum plant</li>
        <li>Appearance: Round, small, pale white to reddish-brown grains</li>
        <li>Taste: Mild, earthy flavor</li>
        <li>Texture: Soft when cooked; slightly coarse when ground into flour</li>
      </ul>

      <h3>Nutritional Benefits:</h3>
      <ul>
        <li>Packed with protein, making it a good plant-based source of energy</li>
        <li>Contains essential vitamins such as B-complex vitamins</li>
        <li>High in minerals like iron, magnesium, phosphorus, and potassium</li>
        <li>Low glycemic index—helps manage blood sugar levels</li>
        <li>Rich in dietary fiber, supporting healthy digestion</li>
      </ul>

      <h3>Applications:</h3>
      <ul>
        <li>Food Products: Jowar flour for rotis, bhakris, dosas, baked goods, Puffed jowar, Porridges, laddus, and traditional recipes</li>
        <li>Health Foods: Used in multigrain atta, diet mixes, and gluten-free blends</li>
        <li>Animal Feed: Commonly used in poultry and livestock feed due to high nutritional value</li>
      </ul>

      <h3>Advantages:</h3>
      <ul>
        <li>Naturally gluten-free</li>
        <li>Sustainable and drought-resistant crop</li>
        <li>Affordable and nutritious</li>
        <li>Increasingly used in healthy and millet-based diets</li>
      </ul>
    </div>
  );
}

const activeTab = {
  padding: "10px 20px",
  background: "green",
  color: "white",
  borderRadius: "8px",
  border: "none",
};

const tab = {
  padding: "10px 20px",
  borderRadius: "8px",
  border: "1px solid #ccc",
};
